import Vue from 'vue'
import router from './index'
import store from '../store'

import NProgress from 'nprogress'
import * as ActionTypes from '@/store/action-types'
import { setTitle } from '@/lib/util'

import wechatAuth from '@/plugins/wechatAuth' // 微信登录插件
import { wxConfigWXApi, hiddenShareItems, startWxAuth, isAttendThePublic } from "../lib/wxShare";
import { Toast } from 'vant'

router.afterEach((to, from) => {
    NProgress.done()
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    to.meta && setTitle(to.meta.title)
    Vue.prototype.$beforeRouter = from;

    console.log('toUrl : ', to.fullPath)

    const loginStatus = Number(store.state.user.loginStatus)//登录状态
    //在微信并且url参数包含回调的url
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.match(/MicroMessenger/i) == "micromessenger" ? true : false;

    //tabbar展示处理
    if (to.meta.showTab) {
        store.dispatch(ActionTypes.SHOW_BOTTOM_TAB)
    } else {
        store.dispatch(ActionTypes.HIDE_BOTTOM_TAB)
    }

    if (process.env.NODE_ENV === "development") {//开发环境
        next()
        return;
    }

    //微信-页面签名
    if (navigator.userAgent.indexOf('iPhone') != -1) {//ios
        if (from.path == '/') {//入口文件需要做签名
            wxConfigWXApi(location.origin + to.fullPath)
        }
    } else {
        if (window.location.href == `${window.origin}/`) {
            wxConfigWXApi(window.location.origin + '/home')
        } else {
            wxConfigWXApi(location.origin + to.fullPath)
        }
    }

    //***************是否只在微信中使用*******************
    if (!isWeixin && to.path !== '/notWeixin') {
        next({ path: '/notWeixin' });
        return;
    }

    if (isWeixin && loginStatus == 1) {


        //================拉取授权=====================
        store.dispatch(ActionTypes.SET_LOGIN_STATUS, 0)
        try {
            wechatAuth.returnFromWechat(to.fullPath)
        } catch (err) {
            console.log('wechatAuth Error : ', JSON.stringify(err))
        }
        // 同意授权 to.fullPath 携带code参数，拒绝授权没有code参数
        const code = wechatAuth.code
        if (code) {
            store
                .dispatch(ActionTypes.LOGIN_WECHAT_AUTH, code)
                .then(res => {
                    store.dispatch(ActionTypes.SET_LOGIN_STATUS, 2)
                    next()
                })
                .catch((err) => {
                    // 失败，设置状态未登录，刷新页面
                    store.dispatch(ActionTypes.SET_LOGIN_STATUS, 0)
                    next()
                })

        } else {
            store.dispatch(ActionTypes.SET_LOGIN_STATUS, 0)
            next()
        }
    } else {
        //拉起授权
        if (!store.state.user.token) {
            startWxAuth()
            return;
        }
        next()
    }

})

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})



//////////////////
// WEBPACK FOOTER
// ./app/router/permission.js
// module id = null
// module chunks = 